module.exports = __webpack_public_path__ + "static/media/05.-8-9.5b2b107e.jpg";